$('.services-category__categories > .container').masonry({
  itemSelector: '.services-category__categories__category',
  columnWidth: '.services-category__categories__category-sizer',
  percentPosition: false,
  gutter: 15
});